import { combineReducers } from 'redux';

import tracking from './tracking';
import deeplink from './deeplink';

export default combineReducers({ tracking, deeplink });
